import { render, staticRenderFns } from "./ReceitasPrincipal.vue?vue&type=template&id=25371258&scoped=true&"
import script from "./ReceitasPrincipal.vue?vue&type=script&lang=js&"
export * from "./ReceitasPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./ReceitasPrincipal.vue?vue&type=style&index=0&id=25371258&lang=scss&scoped=true&"
import style1 from "./ReceitasPrincipal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25371258",
  null
  
)

export default component.exports